import React from 'react';

import AcIcon from '../Icons/AcIcon';
import AcOnIcon from '../Icons/AcOnIcon';
import ArrowDownIcon from '../Icons/ArrowDownIcon';
import ArrowRight from '../Icons/ArrowRight';
import DropArrowIcon from '../Icons/DropArrowIcon';
import OffersIcon from '../Icons/OffersIcon';
import SearchIcon from '../Icons/SearchIcon';
import SeatIcon from '../Icons/SeatIcon';
import SleeperIcon from '../Icons/SleeperIcon';
import SwpIcon from '../Icons/SwpIcon';
import CloseIcon from '../Icons/CloseIcon';
import FilterIcon from '../Icons/FilterIcon';
import SunRiseIcon from '../Icons/SunRiseIcon';
import SunSetIcon from '../Icons/SunSetIcon';
import SunBrightIcon from '../Icons/SunBrightIcon';
import HalfMoonIcon from '../Icons/HalfMoonIcon';
import GreenTickIcon from '../Icons/GreenTickIcon';
import LiveBusIcon from '../Icons/LiveBusIcon';

type IconProps = {
  name: string;
  styleProps?: {
    [k: string]: string; // better typescript – 🐨 css properties
  };
};

const Icon = ({name = '', styleProps}: IconProps) => {
  if (!name) return null;
  switch (name) {
    case 'AcIcon':
      return <AcIcon {...styleProps} />;
    case 'AcOnIcon':
      return <AcOnIcon {...styleProps} />;
    case 'ArrowDownIcon':
      return <ArrowDownIcon {...styleProps} />;
    case 'ArrowRight':
      return <ArrowRight {...styleProps} />;
    case 'DropArrowIcon':
      return <DropArrowIcon {...styleProps} />;
    case 'OffersIcon':
      return <OffersIcon {...styleProps} />;
    case 'SearchIcon':
      return <SearchIcon {...styleProps} />;
    case 'SwpIcon':
      return <SwpIcon {...styleProps} />;
  
    case 'SeatIcon':
      return <SeatIcon {...styleProps} />;
    case 'SleeperIcon':
      return <SleeperIcon {...styleProps} />;
    case 'CloseIcon':
      return <CloseIcon {...styleProps} />;
    
     case 'SunRiseIcon':
      return <SunRiseIcon {...styleProps} />;
    case 'SunSetIcon':
      return <SunSetIcon {...styleProps} />;
    case 'SunBrightIcon':
      return <SunBrightIcon {...styleProps} />;
    case 'FilterIcon':
      return <FilterIcon {...styleProps} />;
    case 'HalfMoonIcon':
      return <HalfMoonIcon {...styleProps} />;
    case 'GreenTickIcon':
      return <GreenTickIcon {...styleProps} />;  
    case 'LiveBus':
      return <LiveBusIcon {...styleProps} />;  
    default:
      return null;
  }
};

export default Icon;
